function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.37737 3.75H9.62265C10.2898 3.75 10.8356 4.3125 10.8356 5C10.8356 6.5625 11.0782 8.0625 11.527 9.4625C11.6604 9.9 11.5634 10.3875 11.2237 10.7375L8.55526 13.4875C10.3019 17.025 13.1159 19.9125 16.5485 21.725L19.217 18.975C19.4596 18.7375 19.7628 18.6125 20.0782 18.6125C20.1995 18.6125 20.3329 18.625 20.4542 18.675C21.8127 19.1375 23.2803 19.3875 24.7844 19.3875C25.4515 19.3875 25.9973 19.95 25.9973 20.6375V25C25.9973 25.6875 25.4515 26.25 24.7844 26.25C13.3949 26.25 4.16443 16.7375 4.16443 5C4.16443 4.3125 4.71025 3.75 5.37737 3.75ZM8.45823 6.25C8.53101 7.3625 8.71295 8.45 9.00406 9.4875L7.54853 10.9875C7.05123 9.4875 6.73586 7.9 6.6267 6.25H8.45823ZM20.4178 21.275C21.4488 21.575 22.504 21.7625 23.5714 21.8375V23.7C21.9703 23.5875 20.4299 23.2625 18.9623 22.7625L20.4178 21.275Z",
  fill: "white"
});

var SvgClickToCallWhitePhone = function SvgClickToCallWhitePhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "assets/click-to-call-white-phone.c017fbe9.svg";
export { SvgClickToCallWhitePhone as ReactComponent };